import { api } from '../api';
import {
  CreateSessionRequest,
  CreateSessionResponse,
  UatSessionSummary,
  UatSessionDetail,
  UatQueryRequest,
  UatQueryResponse,
  UatFeedbackRequest,
} from '../interfaces/Uat.types';

const urlUat = 'uat';

export const uatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSessions: builder.query<UatSessionSummary[], void>({
      query: () => `${urlUat}/sessions`,
      providesTags: ['UAT'],
    }),

    getSession: builder.query<UatSessionDetail, string>({
      query: (sessionId) => `${urlUat}/sessions/${sessionId}`,
      providesTags: (_r, _e, id) => [{ type: 'UAT', id }],
    }),

    getSessionReview: builder.query<UatSessionDetail, string>({
      query: (sessionId) => `${urlUat}/sessions/${sessionId}/review`,
      providesTags: (_r, _e, id) => [{ type: 'UAT', id: `review-${id}` }],
    }),

    createSession: builder.mutation<CreateSessionResponse, CreateSessionRequest>({
      query: (data) => ({
        url: `${urlUat}/sessions`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UAT'],
    }),

    submitSessionQuery: builder.mutation<UatQueryResponse, { sessionId: string; body: UatQueryRequest }>({
      query: ({ sessionId, body }) => ({
        url: `${urlUat}/sessions/${sessionId}/query`,
        method: 'POST',
        body,
      }),
    }),

    getQueryStatus: builder.query<UatQueryResponse, { sessionId: string; queryId: string }>({
      query: ({ sessionId, queryId }) => `${urlUat}/sessions/${sessionId}/query/${queryId}`,
    }),

    submitSessionFeedback: builder.mutation<void, { sessionId: string; body: UatFeedbackRequest }>({
      query: ({ sessionId, body }) => ({
        url: `${urlUat}/sessions/${sessionId}/feedback`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, { sessionId }) => [{ type: 'UAT', id: sessionId }],
    }),

    deleteSession: builder.mutation<void, { sessionId: string; force?: boolean }>({
      query: ({ sessionId, force }) => ({
        url: `${urlUat}/sessions/${sessionId}${force ? '?force=true' : ''}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UAT'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSessionsQuery,
  useGetSessionQuery,
  useGetSessionReviewQuery,
  useCreateSessionMutation,
  useSubmitSessionQueryMutation,
  useGetQueryStatusQuery,
  useSubmitSessionFeedbackMutation,
  useDeleteSessionMutation,
} = uatApi;
